var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-width-1-2 uk-width-1-3@m cardIngredientes"},[_c('div',{staticClass:"elementB"},[_c('img',{attrs:{"src":_vm.info[0].img}}),_vm._v(" "),_c('h2',{staticClass:"title3"},[_vm._v(_vm._s(_vm.info[0].titulo)+" ")]),_vm._v(" "),_c('p',{staticClass:"text1 colorCafe"},[_vm._v(_vm._s(_vm.info[0].texto))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-434e104d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardBeneficios.vue
// module id = 39
// module chunks = 0